import { styled, Typography } from "@material-ui/core";
import {
  EPOCUS_AMBER_BG,
  EPOCUS_AMBER_BORDER,
  EPOCUS_TEXT_SECONDARY,
  rem,
} from "../../_lib/epocus-palette";
import { EXAM_TYPES_BY_WORKSHEET_SET } from "../../_lib/use-enabled-exam-types";
import { SeedDemoStudiesControls } from "../../settings/_lib/seed-demo-studies-controls";
import {
  SettingsCard,
  SettingsCardLabel,
} from "../../settings/_lib/settings-card";
import { useSeedDemoStudies } from "../../settings/_lib/use-seed-demo-studies";

const DemoCard = styled(SettingsCard)({
  border: `1px dashed ${EPOCUS_AMBER_BORDER}`,
  backgroundColor: EPOCUS_AMBER_BG,
});

export const AdminSeedDemoDataCard: FC<{ programId: string }> = ({
  programId,
}) => {
  const { seed, clear, pool, library, loading } = useSeedDemoStudies(programId);

  return (
    <DemoCard>
      <SettingsCardLabel>Seed demo data</SettingsCardLabel>
      <Typography style={{ fontSize: rem(12), color: EPOCUS_TEXT_SECONDARY }}>
        Adds unclaimed studies, with images, to this program's To document
        queue.{" "}
        {library
          ? "Images come from the seed library and match the exam types you pick; a type the program has not enabled is refused."
          : "Images are copied from studies already in this program."}{" "}
        Seeded rows are marked as test scans and stay out of QA numbers.
      </Typography>
      <SeedDemoStudiesControls
        pool={pool}
        library={library}
        loading={loading}
        enabledExamTypes={EXAM_TYPES_BY_WORKSHEET_SET.standard}
        blockedReason={null}
        canClear
        onSeed={(request) => seed(null, request)}
        onClear={clear}
      />
    </DemoCard>
  );
};
